module.exports = __webpack_public_path__ + "img/AT0000000834703.c3821556.png";